import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'

import {
  project_profit_sheet_report_pdf as manual_pdf,
  project_profit_sheet_report_images as manual_images,
} from '../../../static/images/manual'

import bindActionCreators from '../../../lib/utils/bindActionCreators'

import LoadingBar from '../../../lib/components/LoadingBar'
import Manual from '../../../lib/components/Manual'

import { authAction, ppsAction } from '../../../actions'
import { authSelector, ppsSelector } from '../../../selectors'

import { fetchReport, exportExcel, resetModule, resetExportExcel } from './actions'
import { getFetching, getMoreFilter, getExportUrl, getFilter } from './selectors'

import Filter from './components/Filter'
import MoreFilter from './components/MoreFilter'
import Table from './components/Table'

import withAuth from './hocs/withAuth'

import Toolbar from './layout/Toolbar'

/**
 * @typedef {import('react-router-dom').RouteComponentProps} RouteComponentProps
 */

const { resetAuthUser } = authAction
const { redirectAuth } = authSelector

const { closeManual } = ppsAction
const { isManualOpen, isAuthorize } = ppsSelector

/**
 * @typedef {object} Props
 * @property {object} authUser
 * @property {Date} date
 * @property {string} exportUrl
 * @property {boolean} fetching
 * @property {boolean} isManualOpen
 * @property {boolean} authorized
 * @property {{ from: import('moment').Moment, to: import('moment').Moment }} date
 * @property {typeof fetchReport} fetchReport
 * @property {typeof exportExcel} exportExcel
 * @property {typeof resetExportExcel} resetExportExcel
 * @property {typeof resetAuthUser} resetAuthUser
 * @property {typeof resetModule} resetModule
 * @property {typeof closeManual} closeManual
 */

/** @extends {Component<Props & RouteComponentProps>} */
class SummaryTimesheetReport extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'exportUrl')) {
      window.open(get(nextProps, 'exportUrl'))
      nextProps.resetExportExcel()
    }
    return tempState
  }

  componentDidMount = async () => {
    const { fetchReport, authUser, resetAuthUser, history, resetModule } = this.props
    const { redirect, isAuthenticated } = authUser

    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      await resetAuthUser()
      history.replace('/')
    } else {
      await resetModule()
      // javascript object reference issue
      await fetchReport(this.props.filter.month, this.props.filter.year, this.props.filter.project, this.props.filter.lob)
    }
  }

  exportSummaryTimesheetExcel = () => {
    const { exportExcel } = this.props
    exportExcel(this.props.filter.month, this.props.filter.year, this.props.filter.project, this.props.filter.lob)
  }

  searchSummaryTimesheet = async () => {
    const { fetchReport } = this.props
    await fetchReport(this.props.filter.month, this.props.filter.year, this.props.filter.project, this.props.filter.lob)
  }

  render = () => {
    const { fetching, isManualOpen, closeManual, authorized } = this.props

    if (!authorized) {
      return <Redirect to="/home" />
    }

    return (
      <Fragment>
        <LoadingBar isFetching={fetching} />
        <Manual pdf={manual_pdf} images={manual_images} open={isManualOpen} close={closeManual} />
        <Toolbar.Root>
          <Filter clickSearch={this.searchSummaryTimesheet} />
          <Toolbar.Spacer />
          <MoreFilter exportExcel={this.exportSummaryTimesheetExcel} />
        </Toolbar.Root>
        <Table />
      </Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  fetching: getFetching,
  filter: getFilter,
  moreFilter: getMoreFilter,
  exportUrl: getExportUrl,
  authUser: redirectAuth,
  authorized: isAuthorize,
  isManualOpen,
})

const mapDispatchToProps = bindActionCreators({
  fetchReport,
  exportExcel,
  resetExportExcel,
  resetAuthUser,
  resetModule,
  closeManual,
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withAuth
)(SummaryTimesheetReport)



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/page.js